<template>

  <section class="section">

    <div class="container">

      <div class="box">

        <div class="box-header">

          <h3>ການແກ້ໄຂຂໍ້ມູນ Functions</h3>

          <p> ການແກ້ໄຂຂໍ້ມູນ Functions ຂອງທ່ານໄດສຳເລັດແລ້ວ </p>

        </div>

        <div class="columns">

          <button @click="main()" class="button">ກັບສູ່ໜັາຫຼັກ</button>

          <button @click="$router.back()" class="button">
             ກັບສູ່ໜັາກ່ອນນີ້
          </button>

        </div>

      </div>

    </div>

  </section>

</template>

<script>
export default {
  created() {
    window.scrollTo(0, 0);
  },
  methods: {
    main() {
      this.$router.push("/");
    },
  },
};
</script>

<style lang="scss" scoped>
.section {
  background-position: top center;
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  position: relative;

  .container {
    max-width: 860px;
  }
  .box {
    color: #000;
    padding: 50px 40px;
    position: relative;
    .box-header {
      text-align: center;
      position: relative;
      margin-bottom: 30px;

      h3 {
        padding-right: 55px;
        font-size: 35px;
        text-align: center;
        line-height: 1.7;
        color: var(--primary-color);
        margin-bottom: 10px;
      }
      p {
        font-size: 20px;
        text-align: center;
        line-height: 3.3;
        color: var(--primary-color);
        margin-bottom: 10px;
      }
    }
  }
}

button.button {
  background-color: var(--primary-color);
  color: #fff;
  margin-left: auto;
  margin-right: auto;
  display: block;
  font-family: var(--font-family);
}
</style>

